import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  BORDER_LIGHT,
  BRAND_COLOR_TINT,
  SURFACE_TINT,
  TEXT_MUTED,
} from "../utils/colors";


export default function CustomTable({ headers, rows, id }) {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        height: 520,
        border: `1px solid ${BORDER_LIGHT}`,
        borderRadius: "10px",
      }}
    >
      <Table stickyHeader sx={{ width: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell
                key={header}
                align="left"
                size="small"
                sx={{
                  fontWeight: 600,
                  bgcolor: BRAND_COLOR_TINT,
                  py: 1.25,
                }}
              >
                {header}
                {rows?.length > 0 && (
                  <Typography
                    component="span"
                    sx={{
                      ml: 1,
                      fontSize: 12,
                      color: TEXT_MUTED,
                    }}
                  >
                    ({rows.length})
                  </Typography>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={row[id] || index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: SURFACE_TINT },
              }}
            >
              <TableCell align="left" size="small">
                {row[id]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
